module.exports = __webpack_public_path__ + "img/desktop-image-hero-3.63998c1c.jpg";